<template>
  <div id="printArea">
    <div class="d-flex align-center justify-space-between">
      <v-dialog
        ref="dateFrom"
        v-model="modalDateFrom"
        :return-value.sync="dateFrom"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFrom"
            label="Fecha Inicial"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            hide-details
            dense
            outlined
          ></v-text-field>
        </template>
        <v-date-picker v-model="dateFrom" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modalDateFrom = false">
            Cancelar
          </v-btn>
          <v-btn text color="primary" @click="$refs.dateFrom.save(dateFrom)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <div>
        <v-dialog
          ref="dateTo"
          v-model="modalDateTo"
          :return-value.sync="dateTo"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateTo"
              label="Fecha Final"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              class="ml-4"
              hide-details
              dense
              outlined
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateTo" scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalDateTo = false">
              Cancelar
            </v-btn>
            <v-btn text color="primary" @click="$refs.dateTo.save(dateTo)">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </div>
      <div>
        <v-btn
          @click="filterByDate = true"
          :disabled="!dateFrom || !dateTo"
          color="primary"
          class="ml-4"
          >Filtrar por fecha</v-btn
        >
      </div>
      <div>
        <v-switch
          v-model="resolved"
          label="Resueltos"
          class="pa-3 mt-0 ml-4"
          hide-details
          dense
          color="primary"
        ></v-switch>
      </div>
      <div>
        <v-switch
          v-model="notResolved"
          label="No Resueltos"
          class="pa-3 mt-0 ml-4"
          hide-details
          dense
          color="primary"
        ></v-switch>
      </div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="print" v-on="on" class="primary primary mr-2">
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </template>
        <span>Imprimir pantalla</span>
      </v-tooltip>
    </div>
    <v-data-table
      id="fixed-header"
      v-model="selected"
      :headers="headers"
      :items="users"
      item-key="name"
      show-select
    >
      <template v-slot:item.actions="{ item }">
        <ItemParticipant @update="$emit('update')" :participant="item" />
      </template>
    </v-data-table>
    <pre>
    <!-- {{ search }} -->
    </pre>
  </div>
</template>

<script>
import ItemParticipant from "./ItemParticipant";
import { mapMutations } from "vuex";
export default {
  components: { ItemParticipant },
  props: {
    search: Array,
    userData: Object,
  },
  data() {
    return {
      headers: [
        { text: "Número", class: "sticky-header", value: "work" },
        { text: "Nombre", class: "sticky-header", value: "name" },
        { text: "Correo Electrónico", class: "sticky-header", value: "email" },
        { text: "Puesto", class: "sticky-header", value: "position" },
        {
          text: "Área",
          class: "sticky-header",
          value: "personalData.area.option",
        },
        {
          text: "Entidad",
          class: "sticky-header",
          value: "personalData.entity.option",
        },
        { text: "Resolvió", class: "sticky-header", value: "resolvedDisplay" },
        { text: "Clave de acceso", class: "sticky-header", value: "password" },
        { text: "Acciones", class: "sticky-header", value: "actions" },
      ],

      //filters
      resolved: true,
      notResolved: true,
      filterByDate: false,

      selected: [],
      modalDateFrom: false,
      dateFrom: "",
      modalDateTo: false,
      dateTo: "",
    };
  },
  computed: {
    users() {
      var users = this.search;
      users = users.map((user) => {
        user.resolvedDisplay = user.resolved
          ? new Date(user.resolved).toLocaleDateString()
          : "";
        return user;
      });
      users = users.filter((user) => {
        if (this.filterByDate) {
          if (!this.dateFrom || !this.dateTo || !user.resolved) {
            return false;
          } else {
            const from = new Date(this.dateFrom);
            const to = new Date(this.dateTo);
            const resolved = new Date(user.resolved);
            if (resolved > from && resolved < to) {
              return true;
            }
            return false;
          }
        }
        if (this.resolved && user.resolved) {
          return true;
        } else if (this.notResolved && !user.resolved) {
          return true;
        }
        return false;
      });
      return users;
    },
  },
  methods: {
    ...mapMutations(["updateState"]),
    print() {
      var table = document.querySelector("table").innerHTML;

      this.updateState({
        prop: "printData",
        value: table,
      });

      this.$router.push("/print-users");
    },
    fixedHeader() {
      const table = document.querySelector("#fixed-header thead");

      console.log((table.style.position = "absolute"));
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.fixedHeader();
    // }, 5000);
  },
};
</script>

<style>
#fixed-header {
  height: 40vh;
  overflow: auto;
}

.v-data-table .sticky-header {
  position: sticky;
  background: white !important;
  top: 0px;
  border-bottom: solid 1px #333 !important;
}

.v-data-table .v-data-table__wrapper {
  overflow: unset;
}
</style>